import { createSlice } from '@reduxjs/toolkit';
import { IProductState } from './types';
import {
    addPurchase,
    setProducts,
    setPurchases,
    removePurchase,
} from './reducer';
import {
    asyncFetchProducts,
    asyncFetchPurchases,
    asyncCreatePurchase,
    asyncDeletePurchase,
} from './thunks';

const initialState: IProductState = {
    products: [],
    purchases: [],
};
export const reducers = {};

const slice = createSlice({
    name: 'settings',
    initialState,
    reducers,
    extraReducers: builder => {
        builder.addCase(asyncFetchProducts.fulfilled, setProducts);
        builder.addCase(asyncFetchPurchases.fulfilled, setPurchases);
        builder.addCase(asyncDeletePurchase.fulfilled, removePurchase);
        builder.addCase(asyncCreatePurchase.fulfilled, addPurchase);
    },
});

export default slice.reducer;
